export default {"src":"/_next/static/media/app-store_badge_zh-cn.5f3f5e42.svg","height":40,"width":109,"blurWidth":0,"blurHeight":0};